import { Component, Input, SimpleChanges, OnChanges, ViewChildren, ViewContainerRef, QueryList } from '@angular/core';

import { DYNAMIC_FIELDSET_ANCHOR } from 'app/fs/res/common/model/dynamic-content/constants';
import { ProviderManager } from 'app/fs/res/common/utils/provider-manager';

import { ResearchInfrastructureOrganisation } from 'app/fs/res/research-infrastructure/model/research-infrastructure-classes';
import { ResearchInfrastructure } from 'app/fs/res/research-infrastructure/model/research-infrastructure';

@Component( {
    selector: 'res-research-infrastructure-data-tab',
    templateUrl: './research-infrastructure-data-tab.component.html',
    providers: [ProviderManager.getComponentProvider(ResearchInfrastructureDataTabComponent)],
} )
export class ResearchInfrastructureDataTabComponent implements OnChanges {
    @Input() researchInfrastructure: ResearchInfrastructure;
    @ViewChildren( DYNAMIC_FIELDSET_ANCHOR, { read: ViewContainerRef } )
        fieldsetViewContainerList: QueryList<ViewContainerRef>;

    public filteredOperators: ResearchInfrastructureOrganisation[] = [];
    public filteredCoordinators: ResearchInfrastructureOrganisation[] = [];

    ngOnChanges( changes: SimpleChanges ) {
        if ( changes.researchInfrastructure ) {
            this.setFilteredOperators();
            this.setFilteredCoordinators();
        }
    }

    /**
     * Implementation of EventEmitter method organizationsChange for operators
     *
     * @param event GenericValue containing the filtered and selected organizations
     */
    public operatorsChange( event: ResearchInfrastructureOrganisation[] ) {
        this.researchInfrastructure.researchInfrastructureOrganisations = [...this.filteredCoordinators, ...event];
        this.setFilteredOperators();
    }

    /**
     * Implementation of EventEmitter method organizationsChange for coordinators
     *
     * @param event GenericValue containing the filtered and selected organizations
     */
    public coordinatorsChange( event: ResearchInfrastructureOrganisation[] ) {
        this.researchInfrastructure.researchInfrastructureOrganisations = [...this.filteredOperators, ...event];
        this.setFilteredCoordinators();
    }

    private setFilteredOperators() {
        this.filteredOperators = this.researchInfrastructure.researchInfrastructureOrganisations.filter(
            ( organisation: ResearchInfrastructureOrganisation ) => organisation.isCoordinator !== true );
    }

    private setFilteredCoordinators() {
        this.filteredCoordinators = this.researchInfrastructure.researchInfrastructureOrganisations.filter(
            ( organisation: ResearchInfrastructureOrganisation ) => organisation.isCoordinator === true );
    }

}
